/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './app.component.sass.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../app/app.component';
import * as i3 from './header/header.component.ngfactory';
import * as i4 from '../../app/header/header.component';
import * as i5 from '@ngx-translate/core/src/translate.service';
import * as i6 from '@angular/router';
import * as i7 from './footer/footer.component.ngfactory';
import * as i8 from '../../app/footer/footer.component';
const styles_AppComponent:any[] = [i0.styles];
export const RenderType_AppComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AppComponent,
    data:{}});
export function View_AppComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-header',([] as any[]),
      (null as any),[[(null as any),'changeLanguage'],['window','scroll']],(_v,en,
          $event) => {
        var ad:boolean = true;
        var _co:i2.AppComponent = _v.component;
        if (('window:scroll' === en)) {
          const pd_0:any = ((<any>i1.ɵnov(_v,1).onScroll($event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('changeLanguage' === en)) {
          const pd_1:any = ((<any>_co.changeLanguage($event)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i3.View_HeaderComponent_0,i3.RenderType_HeaderComponent)),i1.ɵdid(114688,(null as any),
      0,i4.HeaderComponent,[i5.TranslateService,i6.ActivatedRoute],(null as any),{changeLanguage:'changeLanguage'}),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(16777216,(null as any),
          (null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),
          (null as any),(null as any),(null as any))),i1.ɵdid(212992,(null as any),
          0,i6.RouterOutlet,[i6.ChildrenOutletContexts,i1.ViewContainerRef,i1.ComponentFactoryResolver,
              [8,(null as any)],i1.ChangeDetectorRef],(null as any),(null as any)),
      (_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          1,'app-footer',([] as any[]),(null as any),(null as any),(null as any),i7.View_FooterComponent_0,
          i7.RenderType_FooterComponent)),i1.ɵdid(114688,(null as any),0,i8.FooterComponent,
          ([] as any[]),(null as any),(null as any)),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    _ck(_v,1,0);
    _ck(_v,4,0);
    _ck(_v,7,0);
  },(null as any));
}
export function View_AppComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-root',([] as any[]),
      (null as any),(null as any),(null as any),View_AppComponent_0,RenderType_AppComponent)),
      i1.ɵdid(114688,(null as any),0,i2.AppComponent,[i5.TranslateService,i6.Router],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AppComponentNgFactory:i1.ComponentFactory<i2.AppComponent> = i1.ɵccf('app-root',
    i2.AppComponent,View_AppComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2FyaWFkbmFlcmNpbGxhbW9udHNlcnJhdC9EZXNrdG9wL0ZFSU5BL3BvcnRmb2xpby9wb3J0Zm9saW9fYXJpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9hcmlhZG5hZXJjaWxsYW1vbnRzZXJyYXQvRGVza3RvcC9GRUlOQS9wb3J0Zm9saW8vcG9ydGZvbGlvX2FyaS9zcmMvYXBwL2FwcC5jb21wb25lbnQudHMiLCJuZzovLy9Vc2Vycy9hcmlhZG5hZXJjaWxsYW1vbnRzZXJyYXQvRGVza3RvcC9GRUlOQS9wb3J0Zm9saW8vcG9ydGZvbGlvX2FyaS9zcmMvYXBwL2FwcC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL2FyaWFkbmFlcmNpbGxhbW9udHNlcnJhdC9EZXNrdG9wL0ZFSU5BL3BvcnRmb2xpby9wb3J0Zm9saW9fYXJpL3NyYy9hcHAvYXBwLmNvbXBvbmVudC50cy5BcHBDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLWhlYWRlciAoY2hhbmdlTGFuZ3VhZ2UpPVwiY2hhbmdlTGFuZ3VhZ2UoJGV2ZW50KVwiPjwvYXBwLWhlYWRlcj5cbjxyb3V0ZXItb3V0bGV0Pjwvcm91dGVyLW91dGxldD5cbjxhcHAtZm9vdGVyPjwvYXBwLWZvb3Rlcj5cbjwhLS0gPGRpdiBjbGFzcz1cImJveC1sb2FkaW5nXCI+PGkgY2xhc3M9XCJmYSBmYS1zcGlubmVyIGZhLXB1bHNlIGZhLWZ3XCI+PC9pPjwvZGl2PiAtLT4iLCI8YXBwLXJvb3Q+PC9hcHAtcm9vdD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDQUE7TUFBQTtnQkFBQTtRQUFBO1FBQUE7UUFBQTtVQUFBO1VBQUE7UUFBQTtRQUFZO1VBQUE7VUFBQTtRQUFBO1FBQVo7TUFBQSxtRUFBQTtNQUFBO01BQW1FLHVDQUNuRTtVQUFBO1VBQUEsbURBQUE7VUFBQTtjQUFBO01BQStCLHVDQUMvQjtVQUFBO3VDQUFBLFVBQUE7VUFBQSwyQ0FBeUI7VUFBQTtJQUZ6QjtJQUNBO0lBQ0E7Ozs7b0JDRkE7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/app.component.ngfactory.ts